import { ResourceId } from 'framework/crud';

const PERMISSIONS_EXPIRES_IN_MS = 60 * 1000;

interface CachedPermissions {
  permissions: Promise<string[]>;
  expiresAt: number;
}

const cache = new Map<string, CachedPermissions>();

export const loadEmployeePermissionsOnce = (
  id: ResourceId,
  loadPermissions: () => Promise<string[]>,
): Promise<string[]> => {
  const key = String(id);
  const cached = cache.get(key);

  if (cached && cached.expiresAt > Date.now()) {
    return cached.permissions;
  }

  const permissions = loadPermissions().catch(error => {
    cache.delete(key);
    throw error;
  });

  cache.set(key, { permissions, expiresAt: Date.now() + PERMISSIONS_EXPIRES_IN_MS });

  return permissions;
};

export const clearEmployeePermissionsCache = () => cache.clear();
